module.exports = "/_next/static/images/RoostifyImage-6a8da2b26d59b77e3c0546affa2ace05.jpg";